module.exports = __webpack_public_path__ + "static/media/schedule-reports.45e34bf5.svg";